import API from '../../utils/Api'
import i18n from '@/plugins/i18n'

const api = new API('instructions')


const state = {
  list: [],
  loading: false,
  model: {
    name : ""
  }
}

const getters = {
  
  headers () {
    return [
      {
        text: i18n.t('instructions.name'),
        align: 'center',
        value: 'name'
      },
      {
        text: i18n.t('general.actions'),
        align: 'center',
        sortable: false
      }
    ]
  },

  loading (state) {
    return state.loading
  },

  list (state) {
    return state.list
  },

  model (state) {
    return state.model
  }
}

const actions = {
  async getOne({ commit }, id) {
    try {
      commit('SET_loading', true)
      let res = await api.get(id)
      commit('SET_loading', false)
      return res.data
    } catch (error) {
      commit('interfaceSettings/SET_notification', { success: false, message: i18n.t('notifications.instructions.getOneError') + error.message }, { root: true })
    }
  },
  
  async getAll({ commit }) {
    try {
      commit('SET_loading', true)
      let res = await api.getAll()
      commit('SET_list', res.data)
      commit('SET_loading', false)
    } catch (error) {
      commit('SET_loading', false)
      commit('interfaceSettings/SET_notification', { success: false, message: i18n.t('notifications.instructions.getAllError') + error.message }, { root: true })
    }
  },

  async add({ commit }, data) {
    try {
      commit('SET_loading', true)
      let res = await api.post(data, '')
      commit('ADD_list', res.data)
      commit('SET_loading', false)
      commit('interfaceSettings/SET_notification', { success: true, message: i18n.t('notifications.instructions.add') }, { root: true })
      return true
    } catch (error) {
      commit('SET_loading', false)
      commit('interfaceSettings/SET_notification', { success: false, message: i18n.t('notifications.instructions.addError') + error.message }, { root: true })
      return false
    }
  },

  async update({ commit }, params) {
    try {
      commit('SET_loading', true)
      let res = await api.put(params.id, params.data, "")
      commit('UPDATE_list', res.data)
      commit('SET_loading', false)
      commit('interfaceSettings/SET_notification', { success: true, message: i18n.t('notifications.instructions.update') }, { root: true })
      return true
    } catch (error) {
      commit('SET_loading', false)
      commit('interfaceSettings/SET_notification', { success: false, message: i18n.t('notifications.instructions.updateError') + error.message }, { root: true })
      return false
    }
  },

  async addNewSlide({ commit }, params) {
    try {
      commit('SET_loading', true)
      let res = await api.upload(params.id, params.data, 'add-slide')
      commit('UPDATE_list', res.data)
      commit('SET_loading', false)
      commit('interfaceSettings/SET_notification', { success: true, message: "L'instruction à bien été ajouté" }, { root: true })
      return true
    } catch (error) {
      commit('SET_loading', false)
      commit('interfaceSettings/SET_notification', { success: false, message: "Erreur lors de l'ajout de l'instruction : " + error.message }, { root: true })
      return false
    }
  },

  async updateSlide({ commit }, params) {
    try {
      commit('SET_loading', true)
      let res = await api.upload(params.id, params.data, 'update-slide/' + params.slide)
      commit('UPDATE_list', res.data)
      commit('SET_loading', false)
      commit('interfaceSettings/SET_notification', { success: true, message: "L'instruction à bien été modifiée" }, { root: true })
      return true
    } catch (error) {
      commit('SET_loading', false)
      commit('interfaceSettings/SET_notification', { success: false, message: "Erreur lors de la modification de l'instruction : " + error.message }, { root: true })
      return false
    }
  },

  async deleteSlide({ commit }, params) {
    try {
      commit('SET_loading', true)
      let res = await api.deleteSubElement(params.id, 'slide', params.slide)
      commit('UPDATE_list', res.data)
      commit('SET_loading', false)
      commit('interfaceSettings/SET_notification', { success: true, message: "L'instruction à bien été ajouté" }, { root: true })
      return true
    } catch (error) {
      commit('SET_loading', false)
      commit('interfaceSettings/SET_notification', { success: false, message: "Erreur lors de l'ajout de l'instruction : " + error.message }, { root: true })
      return false
    }
  },

  async delete({ commit }, params) {
    try {
      commit('SET_loading', true)
      await api.deleteMany(params)
      commit('DELETE_list', params)
      commit('SET_loading', false)
      commit('interfaceSettings/SET_notification', { success: true, message: i18n.t('notifications.demandProfiles.delete') }, { root: true })
      return true
    } catch (error) {
      commit('SET_loading', false)
      commit('interfaceSettings/SET_notification', { success: false, message: i18n.t('notifications.demandProfiles.deleteError') + error.message }, { root: true })
      return false
    }
  }
}

const mutations = {
  DELETE_list(state, toDelete) {
    for (let i = 0; i < toDelete.length; i++) {
      for (let index = 0; index < state.list.length; index++) {
        if (state.list[index]._id === toDelete[i]) {
          state.list.splice(index, 1)
          break
        }
      }
    }
  },

  UPDATE_list(state, val) {
    for (let index = 0; index < state.list.length; index++) {
      if (state.list[index]._id === val._id) {
        state.list.splice(index, 1, val)
        break
      }
    }
  },

  ADD_list(state, val) {
    state.list.push(val)
  },

  SET_list(state, val) {
    state.list = val
  },

  SET_loading(state, val) {
    state.loading = val
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}